import React from "react";
import Typewriter from 'typewriter-effect';
import Typography from '@mui/material/Typography';
import AOS from "aos";
import "aos/dist/aos.css";
import Connect from "../Connection/Connect";
import './Home.scss';
import './Flies.scss';

const Home = () => {

    React.useEffect(() => {
        AOS.init();
        AOS.refresh();
    }, []);

    return (

        <div id="home" className="home-div d-flex justify-content-center align-items-center flex-column"> 

            <div className="flies-container" >

                {
                    Array.apply(null, { length: 200 }).map((e, index) => (
                            <div key={index} className="circle-container">
                                <div className="circle"></div>
                            </div>
                        )
                    )
                }

            </div>
        
            <Typography variant="h5" gutterBottom component="div">
                Hey There, I am
            </Typography>

            <div 
                data-aos="zoom-out"
                data-aos-delay="150"
                data-aos-duration="900"
            >
                <Typography variant="h2" gutterBottom component="div">
                    <span className="initial">A</span>nshika <span className="initial">A</span>grawal
                </Typography>
            </div>

            <Typography className="type-writer" variant="h5" gutterBottom component="div">
                I am&nbsp;
                <Typewriter
                    options={{
                        strings: ['a Coding Enthusiast', 'an Open Source Contributor', 'a MERN Stack Developer'],
                        autoStart: true,
                        loop: true,
                        deleteSpeed:20,
                    }}
                />
            </Typography>

            <Connect />

            <div className="img-box">
                <img src="./images/icons/Anshika.jpg" alt="" />
            </div>
        </div>
        
    );
}

export default Home;